import styled from 'styled-components';
import PollDetails from 'src/modules/community/poll/pollDetails';
import PollAnswers from 'src/modules/community/poll/pollAnswers';

export default function Poll(): JSX.Element {
  return (
    <PollContainer>
      <PollDetails />
      <PollAnswers />
    </PollContainer>
  );
}

const PollContainer = styled.div`
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid ${({ theme }) => theme.colorGreyLight};
`;
